let a=0;
const AboutMe = [
    {
        id: ++a,
        title: `${a} Personal Information`,
        data: [
            "Abdul Daim",
            "30th January, 2002",
            "Email: gdaim551@gmail.com"
        ]
    },
    {
        id: ++a,
        title: `${a} Objective`,
        data: [
            "A highly determined and hard-working individual looking for a challenging position to contribute to the success of the company and gain practical experience as well."
        ]
    },
    {
        id: ++a,
        title: `${a} Technical Skills`,
        data: [
            "UI/UX Designer and MERN Developer",
            "Languages: JavaScript, HTML/CSS/Bootstrap, Java, C++, C",
            "React Design Frameworks: Ant Design/Material-UI/React Bootstrap",
            "Wordpress Developer",
            "Knowledge of HCI",
            "Software Usage: Figma, Adobe XD, Adobe Illustrator, Balsamiq, VS Code, Postman, Active Presenter, Vysor, MS Office",
            "Typing Speed: 45 WPM",
        ]
    },
    {
        id: ++a,
        title: `${a} Education`,
        data: [
            "BS Software Engineering",
            "FSc. Pre-Engineering",
        ]
    },
    {
        id: ++a,
        title: `${a} Academic Performance`,
        data: [
            "CGPA: 3.68",
        ]
    },
    {
        id: ++a,
        title: `${a} Strengths`,
        data: [
            "Good written and communication skills",
            "Creative thinker",
            "Team leading abilities",
        ]
    },
    {
        id: ++a,
        title: `${a} Work Experience`,
        data: [
            "Did internship of 6 weeks at Invictus360 and gained experience of mobile and web designing. (Summer 2021)",
            "Did internship of 4 weeks at SayabiDevs as a Full Stack Web Developer. (Summer 2022)"
        ]
    },
    {
        id: ++a,
        title: `${a} Achievements`,
        data: [
            "Please Check \"My Projects\" and \"My Certifications\" Page."
        ]
    },

];

export default AboutMe;